import React, { useEffect, useState } from 'react';
import { Grid, Button } from '@material-ui/core';
import { ModalWrapper } from 'components/Modals';
import { useDispatch, useSelector } from 'react-redux';
import { RootStore } from 'redux/store';
import { LoaderButton } from 'components/LoaderButton';
import { resetEndSeasonSuccess } from 'redux/actions/team';
import { endSeason } from 'redux/thunks';
import { EditSeason } from 'redux/models/editSeason';
import './EndSeasonModal.scss';

interface EndSeasonModalProps {
	open: boolean;
	season: EditSeason;
	onCloseClicked: () => void;
	allowClickOutsideToClose?: boolean;
}

const EndSeasonModal: React.FC<EndSeasonModalProps> = (props: EndSeasonModalProps) => {
	const endingSeason = useSelector((state: RootStore) => state.team.endingSeason);
	const endingSeasonSuccess = useSelector((state: RootStore) => state.team.endingSeasonSuccess);
	const dispatch = useDispatch();
	const [firstEggVisible, setFirstEggVisible] = useState(false);
	const [secondEggVisible, setSecondEggVisible] = useState(false);
	const { open, season, allowClickOutsideToClose, onCloseClicked } = props;

	const endSeasonConfirmed = () => {
		dispatch(endSeason(season as EditSeason));
	};

	useEffect(() => {
		if (open) {
			setTimeout(() => {
				setFirstEggVisible(true);
			}, 10000);
			setTimeout(() => {
				setSecondEggVisible(true);
			}, 25000);
		}
	}, [open]);

	useEffect(() => {
		if (endingSeasonSuccess) {
			dispatch(resetEndSeasonSuccess());
			onCloseClicked();
		}
		setFirstEggVisible(false);
		setSecondEggVisible(false);
	}, [endingSeasonSuccess, dispatch, onCloseClicked]);

	return (
		<ModalWrapper open={open} onCloseClicked={onCloseClicked} allowClickOutsideToClose={allowClickOutsideToClose}>
			<Grid container direction='column' alignItems='center' className='end-season-modal'>
				<h3 className='end-season-modal__title'>End {season?.seasonName}</h3>
				<div className='end-season-modal__body'>
					Are you sure you want to end <span className='end-season-modal__season-name'>{season?.seasonName}</span>? When a season is ended, the team
					is locked and no more tokens can be sent. To begin sending tokens again, you will need to start a new season. Starting a new season will
					clear the current token totals for each user. This cannot be undone.
				</div>
				{firstEggVisible ? <div className='end-season-modal__body-egg'>Seriously, it can't be undone.</div> : <></>}
				{secondEggVisible ? (
					<div className='end-season-modal__body-egg'>
						Like, seriously, the season will be gone, over, done with. It'll be ok, but never the same.
					</div>
				) : (
					<></>
				)}
				<Grid justify='space-between' item container className='end-season-modal-buttons__container'>
					<Button variant='contained' color='primary' onClick={onCloseClicked}>
						Back
					</Button>
					<LoaderButton
						type='button'
						loading={endingSeason}
						onHandleClick={endSeasonConfirmed}
						variant='outlined'
						className='end-season-modal__delete-button'
					>
						End Season
					</LoaderButton>
				</Grid>
			</Grid>
		</ModalWrapper>
	);
};

export default EndSeasonModal;
